import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { DropdownToggle, InputGroup, UncontrolledDropdown } from "reactstrap"
import { DropdownItem, DropdownMenu } from "components/common/Dropdown"
import { useMatch, useNavigate } from "react-router-dom"
import { oldRoutes } from "router/old-routes"
import GooglePlacesInput from "modules/google/GooglePlacesInput"

import useForm from "hooks/useForm"
import useSearchFilter, { toAccessSearchString } from "hooks/useSearchFilter"

import { /* ACTIVITIES, */ GUESTS, TRIP_FILTERS } from "constants/trip"
import { Button } from "antd"
import styles from "./style.module.css"

const cx = (...xs) => xs.filter(Boolean).join(" ")

SearchTrips.propTypes = {
  className: PropTypes.string
}
export default function SearchTrips({ className }) {
  const navigate = useNavigate()
  const placeInputRef = useRef()
  const isTripsPage = useMatch(oldRoutes.tripsPath())
  const [params] = useSearchFilter({ accessAttributes: TRIP_FILTERS })
  const [form, changeHandler, submitHandler, submitCallback, reset, isChanged] = useForm(params)

  const placeChangedHandler = (event) => {
    const { value, coordinates } = event.target

    // Update address
    changeHandler({ target: { name: "address", value } })

    // Update coordinates if available
    if (coordinates) {
      changeHandler({ target: { name: "lat", value: coordinates.lat } })
      changeHandler({ target: { name: "lng", value: coordinates.lng } })
    }
  }

  submitCallback(() => {
    const search = toAccessSearchString(form, TRIP_FILTERS)
    navigate({ pathname: oldRoutes.tripsPath(), search })
  })

  useEffect(() => {
    if (placeInputRef.current) placeInputRef.current.value = form.address ? form.address : ""
  }, [form.address])

  useEffect(() => {
    if (!isTripsPage) {
      reset()
      if (placeInputRef.current) placeInputRef.current.value = ""
    }
    //eslint-disable-next-line
  }, [isTripsPage])

  const classes = cx("hstack", "gap-2", "flex-wrap", className)

  return (
    <form className={classes} onSubmit={submitHandler}>
      <InputGroup className={cx(styles.headerInputGroup, "p-xxs")} type="dropdown p-xs">
        <GooglePlacesInput
          placeholder="Search Location"
          className={styles.searchInput}
          defaultValue={form.address}
          onChange={placeChangedHandler}
          wrapperProps={{ className: "h-100 flex-fill" }}
          ref={placeInputRef}
        />
        <UncontrolledDropdown direction="down">
          <DropdownToggle
            className={cx(styles.guestDropdown, form.guest_count ? "text-dark" : "text-gray-light")}
            caret
            outline
            color="dark"
          >
            {form.guest_count || "Guests"}
          </DropdownToggle>
          <DropdownMenu>
            {GUESTS.map((guests) => (
              <DropdownItem key={guests} name="guest_count" value={guests} onClick={changeHandler}>
                {guests}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
        {/* <DatePicker className={styles.headerDatePicker} suffixIcon={""} /> */}
        <Button color="blue" variant="solid" htmlType="submit" className={cx(styles.SearchTripsBtn, !isChanged && "disabled")}>
          Search Trips
        </Button>
      </InputGroup>
    </form>
  )
}
